import e from "clsx";
import { extendTailwindMerge as l } from "tailwind-merge";
import { placeboTailwindPlugin as a } from "./theme/tailwindPlugin.js";
const i = l({
  classGroups: {
    "font-size": [
      "text-largeTitleMobile",
      "text-largeTitle",
      "text-title1Mobile",
      "text-title1",
      "text-title2Mobile",
      "text-title2",
      "text-title3Mobile",
      "text-title3",
      "text-title4",
      "text-subtitle1Mobile",
      "text-subtitle1",
      "text-subtitle2Mobile",
      "text-subtitle2",
      "text-largeBody",
      "text-smallBody",
      "text-strongSmallBody",
      "text-strong",
      "text-body",
      "text-button",
      "text-preTitleMobile",
      "text-preTitle"
    ],
    placebo: [{ placebo: ["container", "container-w-full"] }]
  }
});
function n(...t) {
  return i(e(t));
}
export {
  n as cn,
  a as placeboTailwindPlugin
};
